export default __webpack_public_path__ + "static/media/buy.a5532519.svg";